// extracted by mini-css-extract-plugin
module.exports = {"MenuBtn":"MenuButton_MenuBtn__3uTKJ","CrossBtn":"MenuButton_CrossBtn__noVDc"};